import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import firebase, { storage } from 'firebase';
// import createSagaMiddleware from 'redux-saga';

import { getFirebase } from 'react-redux-firebase';
import { reduxFirestore, getFirestore, createFirestoreInstance } from 'redux-firestore';
import persistReducers from './persistReducers';
import rootReducer from './rootReducers';
// import rootSaga from './rootSaga';
import fbConfig from '../config/database/firebase';

// const sagaMonitor = process.env.NODE_ENV === 'development' ? null : null;

// const sagaMiddleware = createSagaMiddleware({ sagaMonitor });

const store = createStore(
  persistReducers(rootReducer),
  compose(
    applyMiddleware(
      // sagaMiddleware,
      thunk.withExtraArgument({
        getFirebase,
        getFirestore,
        storage,
        //  sagaMiddleware
      }),
    ),
    reduxFirestore(fbConfig),
  ),
);

export const rrfProps = {
  firebase,
  config: (fbConfig, { useFirestoreForProfile: true, userProfile: 'users', attachAuthIsReady: true }),
  dispatch: store.dispatch,
  createFirestoreInstance,
};

// sagaMiddleware.run(rootSaga);
export default store;
